import ScheduleConfirmView from './ScheduleConfirmView';

export default ScheduleConfirmView;
